import $ from 'jquery';
import { generateId } from '../../../../../@infinite/scripts/core/INF-generateId';

export default (container = document) => {
  $('.rte .tab-heading', container).each((i, el) => {
    const $tabHeading = $(el);
    const $content = $tabHeading.siblings('.tab-content');
    const $container = $tabHeading.parent('li');

    $container.addClass('rte-accordion');

    // accessibility needs an id
    let accordion_id = $container.attr('id');

    if (!accordion_id) {
      accordion_id = generateId();
      $container.attr('id', accordion_id);
    }

    $tabHeading.append(`
      <div class="TabToggle" tabindex="0" role="button" data-tab-toggle>
        <div class="TabToggle__closed"><img src="${theme.images.plus}"></div>
        <div class="TabToggle__opened"><img src="${theme.images.minus}"></div>
      </div>
    `);

    if (!$tabHeading.find('[data-tab-toggle]').eq(0).attr('aria-controls')) {
      $tabHeading.find('[data-tab-toggle]').eq(0).attr('aria-controls', accordion_id);
    }

    $container.css({
      overflow: 'hidden',
      paddingLeft: 0,
    });

    if ($container.parents('[data-grey-accordion]').length === 0) {
      $container.css({
        backgroundImage: `url(${theme.images.hr_dark})`,
        backgroundPosition: 'center top',
        backgroundRepeat: 'repeat-x',
      });

      $container.parent().css({
        backgroundImage: `url(${theme.images.hr_dark})`,
        backgroundPosition: 'center bottom',
        backgroundRepeat: 'repeat-x',
      });

      $content.data('background', 'transparent');
      $content.css({
        background: 'transparent',
      });

      $tabHeading.css({
        background: 'transparent',
      });
    }

    if ($container.parent().css('maxWidth') === 'none') {
      $container.parent().css({
        marginLeft: 0,
      });
    }

    $content.clone().addClass('tab-content--height-calc').attr('data-tab-height-calc', true).appendTo($tabHeading);
  });
};